import { ref, type Ref } from 'vue';
import axios, { AxiosError } from 'axios';
import { useRuntimeConfig } from '#imports';
import type { TournamentEntryFormResponse } from '~/types/types';

export interface UseTournamentEntryFormResult {
   form: Ref<TournamentEntryFormResponse | null>;
   isLoading: Ref<boolean>;
   notFound: Ref<boolean>;
   error: Ref<Error | null>;
   fetchForm: () => Promise<void>;
}

export function useTournamentEntryForm(portal: string): UseTournamentEntryFormResult {
   const config = useRuntimeConfig();
   const baseUrl = config.public.lmsApiBaseurl as string;

   const form = ref<TournamentEntryFormResponse | null>(null);
   const isLoading = ref(false);
   const notFound = ref(false);
   const error = ref<Error | null>(null);

   const fetchForm = async () => {
      isLoading.value = true;
      notFound.value = false;
      error.value = null;

      try {
         const response = await axios.get<TournamentEntryFormResponse>(
            `${baseUrl}portals/${portal}/tournament-entry-form`
         );
         form.value = response.data;
      } catch (e) {
         const axiosError = e as AxiosError;
         if (axiosError.response?.status === 404) {
            notFound.value = true;
            form.value = null;
         } else {
            error.value = axiosError;
         }
      } finally {
         isLoading.value = false;
      }
   };

   return { form, isLoading, notFound, error, fetchForm };
}
